// extracted by mini-css-extract-plugin
export default {"authenticationBackButton":"authenticationBackButton_nJX7JGv"};